import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class CommunicationService {

    static getCommunication = (callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/communication`, callback, errCallback, queryParams);
    };

    // Casella del fornitore: mail automatiche ricevute + messaggi in entrambe le direzioni.
    static getInbox = (companyId, callback, errCallback) => {
        NetworkService.get(`${API_BASE_URL}/company/${companyId}/communications`, callback, errCallback);
    };

    static createCommunication = (body, callback, errCallback, queryParams) => {
        NetworkService.postMultiPart(`${API_BASE_URL}/communication`, body, callback, errCallback, queryParams);
    };
}
